import constantCreator from 'utils/constantCreator';
import api from 'utils/api';

const define = constantCreator('config');
const LOAD_CONFIG = define('LOAD_CONFIG', true);
const LOAD_USER_CONFIG = define('LOAD_USER_CONFIG', true);
const UPDATE_CONFIG = define('UPDATE_CONFIG', true);
const LOAD_TRANSLATION = define('LOAD_TRANSLATION', true);
const UPDATE_TRANSLATION_SPREADSHEET = define('UPDATE_TRANSLATION_SPREADSHEET', true);
const LOAD_CONFIG_KEYS = define('LOAD_CONFIG_KEYS', true);
const LOAD_MEETING_POINTS = define('LOAD_MEETING_POINTS', true);
const LOAD_ASSIGNEE = define('LOAD_ASSIGNEE', true);
const LOAD_MANUAL_BOOKING_TYPE = define('LOAD_MANUAL_BOOKING_TYPE', true);

const initialState = {
  isLoading: true,
  configs: {},
  isLoadUserConfig: true,
  userConfig: {},
  isLoadingTranslation: true,
  updatingSpreadsheet: false,
  translations: [],
  isLoadingConfigKey: true,
  configKeys: [],
  isLoadingMeetingPoint: true,
  meetingPoints: [],
  isLoadingAssignee: true,
  assignees: [],
  isLoadmanualBookingType: true,
  manualBookingType: [],
  processing: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CONFIG.PENDING:
      return {
        ...state,
        isLoading: true
      };
    case LOAD_CONFIG.RESOLVED:
      return {
        ...state,
        isLoading: false,
        configs: action.data
      };
    case LOAD_USER_CONFIG.PENDING:
      return {
        ...state,
        isLoadUserConfig: true
      };
    case LOAD_USER_CONFIG.RESOLVED:
      return {
        ...state,
        isLoadUserConfig: false,
        userConfig: action.data
      };
    case LOAD_TRANSLATION.PENDING:
      return {
        ...state,
        isLoadingTranslation: true
      };
    case LOAD_TRANSLATION.RESOLVED:
      return {
        ...state,
        isLoadingTranslation: false,
        translations: action.data
      };
    case UPDATE_TRANSLATION_SPREADSHEET.PENDING:
      return {
        ...state,
        updatingSpreadsheet: true
      };
    case UPDATE_TRANSLATION_SPREADSHEET.RESOLVED:
      return {
        ...state,
        updatingSpreadsheet: false
      };
    case UPDATE_CONFIG.PENDING:
      return {
        ...state,
        processing: true
      };
    case UPDATE_CONFIG.RESOLVED:
      return {
        ...state,
        processing: false
      };
    case LOAD_CONFIG_KEYS.PENDING:
      return {
        ...state,
        isLoadingConfigKey: true,
      };
    case LOAD_CONFIG_KEYS.RESOLVED:
      return {
        ...state,
        isLoadingConfigKey: false,
        configKeys: action.data
      };
    case LOAD_MANUAL_BOOKING_TYPE.PENDING:
      return {
        ...state,
        isLoadmanualBookingType: true,
      };
    case LOAD_MANUAL_BOOKING_TYPE.RESOLVED:
      return {
        ...state,
        isLoadmanualBookingType: false,
        manualBookingType: action.data.manualBookingType || []
      };
    case LOAD_MEETING_POINTS.PENDING:
      return {
        ...state,
        isLoadingMeetingPoint: true,
      };
    case LOAD_MEETING_POINTS.RESOLVED:
      return {
        ...state,
        isLoadingMeetingPoint: false,
        meetingPoints: action.data
      };
    case LOAD_ASSIGNEE.PENDING:
      return {
        ...state,
        isLoadingAssignee: true,
      };
    case LOAD_ASSIGNEE.RESOLVED:
      return {
        ...state,
        isLoadingAssignee: false,
        assignees: action.data
      };
    default: return state;
  }
};

export const actions = {
  loadAllConfig: () => ({
    type: LOAD_CONFIG,
    promise: api.get('/configs/all')
  }),
  loadConfigByKeys: keys => ({
    type: LOAD_CONFIG,
    promise: api.get(`/configs?keys=${keys}`)
  }),
  loadUserConfig: (id) => ({
    type: LOAD_USER_CONFIG,
    promise: api.get(`/configs/${id}`)
  }),
  updateConfig: (id, value) => ({
    type: UPDATE_CONFIG,
    promise: api.put(`/configs/${id}`, value),
    success: 'Update config successfully',
    error: 'Unable to update config'
  }),
  loadTranslation: () => ({
    type: LOAD_TRANSLATION,
    promise: api.get('/translation/admin'),
  }),
  updateTranslationSpreadsheet: () => ({
    type: UPDATE_TRANSLATION_SPREADSHEET,
    promise: api.get('/translation/csv'),
    success: 'Update translation from spreadsheet successfully',
    error: 'Unable to update translation from spreadsheet'
  }),
  getConfigKeys: () => ({
    type: LOAD_CONFIG_KEYS,
    promise: api.get('/info/config_key'),
    error: 'Unable to load config keys'
  }),
  getManualBookingType: () => ({
    type: LOAD_MANUAL_BOOKING_TYPE,
    promise: api.get('/configs?keys=manualBookingType'),
  }),
  getMeetingPoints: () => ({
    type: LOAD_MEETING_POINTS,
    promise: api.get('/info/meeting_point'),
    error: 'Unable to load meeting point'
  }),
  getAssignee: () => ({
    type: LOAD_ASSIGNEE,
    promise: api.get('/configs/all')
      .then(({ data }) => ({
        data: data.filter(d => d.key === 'assignee')
      }))
  })
};



// WEBPACK FOOTER //
// ./src/ducks/config.js